<div class="col m12 bxpadwrap">
    <!-- <div class="post-nav-wrap">
        <div class="title-wrap">
            <p class="title semi-bold">{{gridTitle}}</p>
        </div>
    </div> -->

    <div *ngIf="showAdvanceSearch" class="advanced_search_main_sec">
        <div class="row">
            <div class="col-lg-12">
                <h6 class="advance_search_title">Advanced Search</h6>
            </div>
            <div class="col-lg-11">
                <div class="row">

                </div>

                <div class="row">
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="txtURN">URN</mat-label><input matInput placeholder="URN"
                                [(ngModel)]="txtURN" maxlength="30">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="priority">Priority</mat-label>
                            <mat-select [(ngModel)]="ddlPriority" id="priority">
                                <mat-option *ngFor="let option of lstPriority" [value]="option.value">
                                    {{ option.text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label>Input Type</mat-label><input matInput placeholder="Input Type"
                                [(ngModel)]="txtInputType">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label>Input From</mat-label><input matInput placeholder="Input From"
                                [(ngModel)]="txtInputFrom">
                        </mat-form-field>
                    </div> -->
                    <div class="col-lg-3">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="received_date_range">Received Date Range</mat-label>
                            <mat-date-range-input [min]="commonService.minDate" [rangePicker]="picker"
                                [formGroup]="invoiceCreationDateRange" id="received_date_range">
                                <input matStartDate formControlName="start_date" #startdate placeholder="Start Date"
                                    [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()" readonly>
                                <input matEndDate formControlName="end_date" #endDate placeholder="End Date"
                                    [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()" readonly>
                            </mat-date-range-input>
                            <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                                (click)="resetInvoiceCreationDateRange()">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>


                    </div>
                    <div *ngFor="let field of advanceSearchFields" [ngSwitch]="field.control_type|lowercase"
                        class="col-lg-{{field.control_type=='TEXTAREA'?6:3}}">

                        <mat-form-field *ngSwitchCase="'textbox'" [style.width.%]="100">

                            <input matInput *ngIf="field.value_type=='text' && field.validation_type != 'AMOUNT'"
                                [type]="field.value_type" [placeholder]="field.field_name"
                                [(ngModel)]="field.search_value" />

                            <input matInput *ngIf="field.value_type=='number'" [(ngModel)]="field.search_value"
                                [type]="field.value_type" [placeholder]="field.field_name" class="text-end"
                                (change)="field.search_value=setDecimalPlaces(field.search_value,field.precision_point,field.validation_type);"
                                (input) ="limitLength($event, 20)" />

                            <input matInput *ngIf="field.validation_type == 'AMOUNT'" [(ngModel)]="field.search_value"
                                [type]="field.value_type" [placeholder]="field.field_name" class="text-end"
                                (blur)="commonService.formatCurrencyValue($event)"
                                (change)="field.search_value=setDecimalPlaces(field.search_value,field.precision_point,field.validation_type);" 
                                (input) ="limitLength($event, 20)"/>

                            <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix mat-icon-button
                                (click)="openMagnifySearchModal(field)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>

                        <mat-form-field appearance="legacy" *ngSwitchCase="'dropdown'" [style.width.%]="100">
                            <mat-label for="{field.field_name}">{{field.field_name}}</mat-label>
                            <mat-select [(ngModel)]="field.search_value" (click)="searchText.focus()"
                                (focus)="searchText.focus()" (closed)="searchText.value=''"
                                (selectionChange)="changeDropdownFieldValue(field,field.search_value)"
                                id="field.field_name">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off"
                                    class="mat-select-search" placeholder="Search {{field.field_name}}">
                                <mat-option [value]="option.id"
                                    *ngFor="let option of field.options| listFilter:{'name':searchText.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                            <button *ngIf="field.is_magnify_search==1" mat-button matSuffix mat-icon-button
                                (click)="$event.stopPropagation();openMagnifySearchModal(field)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>

                        <mat-form-field *ngSwitchCase="'date'" [style.width.%]="100">
                            <input matInput readonly [(ngModel)]="field.search_value" [matDatepicker]="picker"
                                [placeholder]="field.field_name" [min]="commonService.minDate">
                            <button *ngIf="field.search_value!=''" mat-button matSuffix mat-icon-button
                                (click)="field.search_value=''">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field *ngSwitchCase="'textarea'" [style.width.%]="100">
                            <textarea matInput [placeholder]="field.field_name" [(ngModel)]="field.search_value"  [attr.maxlength]="field.max_length || 30"
                                rows="1"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-1">
                        <button class="btncss me-2 btn_secondary btn_thin"
                            (click)="clearAdvanceSearchField()">Clear</button>
                    </div>
                </div>
            </div>
            <div class="col-lg-1">
                <div class="advanced_search_action_sec">
                    <a class="btn-floating waves-effect waves-light btn-small ad_search_btn" title="Search"><em
                            class="material-icons left m_0" (click)="submitAdvanceSearch()">search</em></a>
                    <a class="btn-floating waves-effect waves-light btn-small ad_close_btn" title="Close"
                        (click)="showAdvanceSearch=false"><em class="material-icons left m_0">close</em></a>
                </div>
            </div>
        </div>
    </div>

    <div class="table scroll_table">
        <div class="dataTables_info" id="example_info1" role="status" aria-live="polite">
            <span class="title semi-bold">{{gridTitle}}</span>&nbsp;&nbsp;&nbsp;&nbsp;

        </div>
        <!-- <div style="position: absolute;margin-left: 350px;margin-top: -10px;">
            <mat-form-field class="records-per-page">
                <mat-select [(ngModel)]="recordsPerPage" (selectionChange)="changeRecordsPerPage()">
                    <mat-option *ngFor="let page of lstrecordsPerPage" [value]="page">{{page}}</mat-option>
                </mat-select>
            </mat-form-field>
            <span style="font-size: 12px;"> Record(s) per page.</span>
        </div> -->

        <div class="dataTables_paginate paging_simple_numbers" id="example_paginate2">

            <a *ngIf="showAdvanceSearchOption" (click)="showAdvanceSearch=!showAdvanceSearch"
                [class.data-filtered]="isDataFiltered">
                <em class="material-icons" title="Advanced Search">search</em>
            </a>

            <a *ngIf="showExcelDownloadOption" (click)="downloadExcel()">
                <em class="material-icons" title="Export to Excel">file_download</em>
            </a>
            <a>
                <em class="material-icons" #displayGrid [matMenuTriggerFor]="colMenu" title="Display Filter Grid"
                    aria-hidden="true">filter_list</em>
                <mat-menu #colMenu="matMenu" backdropClass="{{isLiteTheme?'column-filter-lite':''}}">
                    <!-- <button mat-stroked-button color="accent" class="btn-save-persona"
                            (click)="$event.stopPropagation();">
                            Save as default</button> -->
                    <div class="col-filter-container">
                        <div *ngFor="let colGroup of lstHeaders">
                            <p class="col-filter-title">{{colGroup.section_name}}</p>
                            <div *ngFor="let col of colGroup.section_fields">
                                <mat-checkbox
                                    *ngIf="col.name!='DOCUMENT_DETAIL_ID' && col.name!='action_checkbox_button'"
                                    [checked]="col.is_visible" (click)="$event.stopPropagation();"
                                    (change)="col.is_visible=$event.checked;columnsFilterChange()">
                                    {{ col.name }}
                                </mat-checkbox>
                            </div>
                            <hr>
                        </div>
                    </div>
                </mat-menu>
            </a>

        </div>

        <div class="btn-group1 next_prev_btn_sec">
            <a (click)="scrollGrid('prev')" class="prev-btn btn" title="chevron_left_arrow">
                <em class="material-icons">chevron_left</em>
            </a>
            <a (click)="scrollGrid('next')" class="nxt-btn btn" title="chevron_right_arrow">
                <em class="material-icons">chevron_right</em>
            </a>
        </div>

        <div *ngIf="lstHeaders.length>0" class="outer_table">
            <div class="scrollable_other_tables">
                <div class="tableHeaderWrp">
                    <table class="sticky" id="left_header">
                        <thead>
                            <tr *ngIf="showColumnGroup" class="main-title">
                                <th class="text-center" *ngIf="hasVisibleColumns(lstHeaders[0].section_fields)"
                                    [attr.colspan]="lstHeaders[0].section_fields.length">
                                    {{lstHeaders[0].section_name}}
                                </th>
                            </tr>
                            <tr>
                                <ng-container *ngFor="let col of lstHeaders[0].section_fields;">
                                    <th *ngIf="!columnsToHide.includes(col.name) && col.is_visible && col.name!='action_checkbox_button' && col.name!='action_dropdown_option'"
                                        (click)="sortByColumn(col.name)" class="custom_width">
                                        {{ col.name }}
                                        <em *ngIf="sortColumnInfo.name==col.name"
                                            class="material-icons sort_materialicon">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}</em>
                                    </th>
                                    <th *ngIf="col.name=='action_checkbox_button'" class="custom_width">
                                        <mat-checkbox [(ngModel)]="isMasterSel"
                                            (change)="HeaderCheckBoxChanged($event)">
                                        </mat-checkbox>
                                    </th>
                                    <th *ngIf="col.name=='action_dropdown_option'" class="custom_width">
                                        To Queue
                                    </th>

                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let row of lstData;let rowIndex=index">
                                <tr
                                    *ngIf="((rowIndex >= (recordsPerPage*(currentPage-1))) && (rowIndex < (recordsPerPage*currentPage)))|| Isserversidepaginationenabled == true">
                                    <ng-container *ngFor="let col of lstHeaders[0].section_fields;let j = index;">
                                        <td *ngIf="!columnsToHide.includes(col.name) && col.is_visible"
                                            [ngStyle]="getCellStyle(col.name)"
                                            [class.table-cell-icon]="col.name == 'Priority' || col.name == 'Attachment'"
                                            (click)="onCellClick(col.name, row,rowIndex)">
                                            <!-- <span *ngIf="col.name != 'Attachment' && col.name != 'Priority' && col.name!='action_checkbox_button' && col.name!='action_dropdown_option'">
                                                {{ row[col.name] }}
                                            </span>  -->


                                            <a *ngIf="showExcelDownloadOption" (click)="downloadExcel()">
                                                <span title="Export to Excel"
                                                    *ngIf="col.name == 'TotalRecordsCount' && col.name != 'Attachment' && col.name != 'Priority' && col.name!='action_checkbox_button' && col.name!='action_dropdown_option'">
                                                    {{ row[col.name] }}
                                                </span>
                                            </a>

                                            <span
                                                *ngIf="col.name != 'TotalRecordsCount' && col.name != 'Attachment' && col.name != 'Priority' && col.name!='action_checkbox_button' && col.name!='action_dropdown_option'">
                                                {{ row[col.name] }}
                                            </span>


                                            <em *ngIf="col.name == 'Attachment'" class="material-icons"
                                                aria-hidden="true">
                                                <span *ngIf="row[col.name]!='' && row.hasOwnProperty('URN')"
                                                    (click)="commonService.openAttachment(row['URN'],'')">download</span>
                                                <span
                                                    *ngIf="row[col.name]=='' || (row[col.name]!='' && !row.hasOwnProperty('URN'))">close</span>
                                            </em>
                                            <em *ngIf="col.name == 'Priority'"
                                                class="material-icons text-{{row[col.name].charAt(0)=='H'?'danger':row[col.name].charAt(0)=='M'?'warning':row[col.name].charAt(0)=='N'?'success':'primary'}}"
                                                aria-hidden="true" style="font-size: 14px;">
                                                {{row[col.name].charAt(0)}}</em>

                                            <mat-checkbox *ngIf="col.name=='action_checkbox_button'" color="primary"
                                                [(ngModel)]="row[col.name]" value="{{row[col.name]}}" fxLayout="column"
                                                (change)="isAllSelected()">
                                            </mat-checkbox>
                                            <mat-select *ngIf="col.name=='action_dropdown_option'"
                                                (selectionChange)="onSelectionChange($event.value,rowIndex,col.name)"
                                                [style.width.px]="115">
                                                <mat-option [value]="doc" *ngFor="let doc of row[col.name]">
                                                    {{doc.text}}
                                                </mat-option>
                                            </mat-select>

                                        </td>
                                    </ng-container>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div #scrollableGrid class="scroll_animation">
                    <div class="innner_scroll">
                        <div *ngFor="let colGroup of lstHeaders;let h=index" class="scroll_tables"
                            [class.first_table]='h==0'>
                            <table *ngIf="h>0" class="other_tables">
                                <thead>
                                    <tr *ngIf="showColumnGroup" class="main-title">
                                        <th class="text-center" *ngIf="hasVisibleColumns(colGroup.section_fields)"
                                            [attr.colspan]="colGroup.section_fields.length">
                                            {{colGroup.section_name}}
                                        </th>
                                    </tr>
                                    <tr>
                                        <ng-container *ngFor="let col of colGroup.section_fields;">
                                            <th *ngIf="col.is_visible" (click)="sortByColumn(col.name)"
                                                class="custom_width">
                                                {{ col.name }}
                                                <em *ngIf="sortColumnInfo.name==col.name"
                                                    class="sort_materialicon material-icons">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}</em>
                                            </th>
                                        </ng-container>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of lstData;let rowIndex=index">
                                        <tr
                                            *ngIf="((rowIndex >= (recordsPerPage*(currentPage-1))) && (rowIndex < (recordsPerPage*currentPage))) || Isserversidepaginationenabled == true">
                                            <ng-container *ngFor="let col of colGroup.section_fields;let j = index;">
                                                <td *ngIf="col.is_visible" [ngStyle]="getCellStyle(col.name)"
                                                    [class.table-cell-icon]="col.name == 'Priority' || col.name == 'Attachment'"
                                                    (click)="onCellClick(col.name, row,rowIndex)">
                                                    <span *ngIf="col.name != 'Attachment' && col.name != 'Priority'">
                                                        {{ row[col.name] }}
                                                    </span>
                                                    <em *ngIf="col.name == 'Attachment'" class="material-icons"
                                                        aria-hidden="true">{{ row[col.name]!=''?'check':'close' }}</em>
                                                    <em *ngIf="col.name == 'Priority'"
                                                        class="material-icons text-{{row[col.name].charAt(0)=='H'?'danger':row[col.name].charAt(0)=='M'?'warning':row[col.name].charAt(0)=='N'?'success':'primary'}}"
                                                        aria-hidden="true" style="font-size: 14px;">
                                                        {{row[col.name].charAt(0)}}</em>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="lstData.length>0" class="dataTables_info dataTables_m0" id="example_info2" role="status"
            aria-live="polite">
            Showing {{firstRecord}} to {{LastRecord}} of {{total_records}} entries &nbsp;&nbsp;&nbsp;&nbsp;
            <mat-form-field class="records-per-page">
                <mat-select [(ngModel)]="recordsPerPage" [attr.role]="null" (selectionChange)="changeRecordsPerPage()">
                    <mat-option *ngFor="let page of lstrecordsPerPage" [value]="page">{{page}}</mat-option>
                </mat-select>
            </mat-form-field>
            <span style="font-size: 12px;"> Record(s) per page.</span>
        </div>
        <div *ngIf="lstData.length>0" class="dataTables_paginate paging_simple_numbers" id="example_paginate1">

            <a class="paginate_button previous disabled" aria-controls="example" data-dt-idx="0" tabindex="0"
                id="example_previous" (click)="changePage('prev',0)">
                <em class="material-icons">chevron_left</em>
            </a>
            <!-- <span *ngIf="pagearray.indexOf(NewPage-5) > -1">....</span> -->
            <span *ngIf=pretrail>....</span>
            <ng-container *ngFor="let page of pagearray; let i = 'index+1'">
                <span *ngIf="isvisiblefn(i)">
                    <a class="paginate_button" [class.current]="NewPage==i" aria-controls="example" data-dt-idx=i
                        tabindex="0" (click)="changePage('',i)">{{i}}</a>
                    <!-- <a class="paginate_button" [class.current]="currentPage==1" aria-controls="example" data-dt-idx="1"
                        tabindex="0" (click)="changePage('',1)">1</a>
                    <a *ngIf="totalPages>=2" class="paginate_button " [class.current]="currentPage==2"
                        aria-controls="example" data-dt-idx="2" tabindex="0" (click)="changePage('',2)">2</a>
                    <a *ngIf="totalPages>=3" class="paginate_button " [class.current]="currentPage==3"
                        aria-controls="example" data-dt-idx="3" tabindex="0" (click)="changePage('',3)">3</a> -->
                </span>

            </ng-container>
            <span *ngIf=posttrail>....</span>

            <a class="paginate_button next" aria-controls="example" data-dt-idx="4" tabindex="0" id="example_next"
                (click)="changePage('next',0)">
                <em class="material-icons">chevron_right</em>
            </a>
        </div>
    </div>
</div>